import { render, staticRenderFns } from "./ServiceSupplement.vue?vue&type=template&id=1feeb8a4&scoped=true"
import script from "./ServiceSupplement.vue?vue&type=script&lang=js"
export * from "./ServiceSupplement.vue?vue&type=script&lang=js"
import style0 from "./ServiceSupplement.vue?vue&type=style&index=0&id=1feeb8a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1feeb8a4",
  null
  
)

export default component.exports